module.exports = __webpack_public_path__ + "img/img (43).25dde119.png";